/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Label, Table } from 'semantic-ui-react';
import currencyFormatter from 'currency-formatter';
import moment from 'moment-timezone';
import globalStyles from '../../globals.scss';
import styles from './Invoice.scss';
import paymentsHelper from '../../../lib/utils/payments';
import Refund from './Refund/';

const Refunds = ({
  canEdit,
  node,
  relay,
  timeZone = moment.tz.guess()
}) => {
  const numRefunds = node.payments.edges.reduce(
    (total, payment) => total + payment.node.refunds.edges.length, 0
  );
  return (
    <Grid>
      {node.payments.edges.length > 0 &&
        <Grid.Row columns='equal'>
          <Grid.Column className={globalStyles.desktop}>
            <Table stackable basic='very' striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Date</Table.HeaderCell>
                  <Table.HeaderCell>Amount</Table.HeaderCell>
                  <Table.HeaderCell>Payment Method</Table.HeaderCell>
                  <Table.HeaderCell>Notes</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {node.payments.edges.map(payment =>
                  payment.node.refunds.edges.map(refund =>
                    <Table.Row key={refund.node.id}>
                      <Table.Cell>
                        <p
                          title={`${moment
                            .tz(refund.node.refunded_at, timeZone)
                            .format('MMM D, YYYY [at] LT')} ${moment
                            .tz(timeZone)
                            .format('z')}`}
                        >
                          {moment
                            .tz(refund.node.refunded_at, timeZone)
                            .format('L')}
                        </p>
                      </Table.Cell>
                      <Table.Cell>
                        {currencyFormatter.format(
                          (refund.node.amount_cents || 0) / 100,
                          {
                            code: refund.node.amount_currency
                          }
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        {paymentsHelper.payments(payment.node)}
                      </Table.Cell>
                      <Table.Cell>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {refund.node.notes}
                        </span>
                      </Table.Cell>
                    </Table.Row>
                  )
                )}
              </Table.Body>
            </Table>
          </Grid.Column>
          <Grid.Column className={globalStyles.mobile} width={16}>
            {node.payments.edges.map(payment =>
              payment.node.refunds.edges.map(refund =>
                <div key={refund.node.id} style={{ marginBottom: '4em' }}>
                  <Grid>
                    <Grid.Row columns='equal'>
                      <Grid.Column>
                        <h3 style={{ marginBottom: '0.5rem' }}>
                          {currencyFormatter.format(
                            (refund.node.amount_cents || 0) / 100,
                            {
                              code: refund.node.amount_currency
                            }
                          )}
                        </h3>
                        <div className={styles.paymentAmountDescription}>
                          <Label
                            size='small'
                            content={paymentsHelper.payments(payment.node)}
                          />
                        </div>
                      </Grid.Column>
                      <Grid.Column textAlign='right'>
                        {moment.tz(refund.node.refunded_at, timeZone).format('L')}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  {refund.node.notes &&
                    <div
                      style={{ marginTop: '1em' }}
                      className={styles.paymentAmountDescription}
                    >
                      <br />Notes: {refund.node.notes}
                    </div>}
                </div>
              )
            )}
          </Grid.Column>
        </Grid.Row>}
      {numRefunds === 0 &&
        <Grid.Row style={{ textAlign: 'center', padding: '2em' }}>
          <Grid.Column>
            <h4>This invoice has no refunds</h4>
            <br />
            <Refund
              node={node}
              trigger={
                <Button
                  basic
                  icon='plus'
                  labelPosition='left'
                  content='Add Refund'
                />
              }
              relay={relay}
            />
          </Grid.Column>
        </Grid.Row>}
      {canEdit && numRefunds > 0 &&
        <Refund
          node={node}
          trigger={
            <a style={{ marginTop: '1em' }}>
              + Add Refund
            </a>
          }
          relay={relay}
        />}
    </Grid>
  );
};

Refunds.propTypes = {
  canEdit: PropTypes.bool,
  node: PropTypes.object.isRequired,
  relay: PropTypes.object,
  timeZone: PropTypes.string
};

export default Refunds;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Refunds.js